/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';
import SocketIO from 'socket.io-client';

window.Echo = new Echo({
    broadcaster: 'socket.io',
    client: SocketIO,
    host: window.location.host,
    reconnectionAttempts: 5,
    reconnectionDelay: 30000,
    reconnectionDelayMax: 60000,
});
